export var DEFAULT_CLASS_NAME = 'accordions-popup-menu-link';
export var DEFAULT_CLOSE_POPUP_TIMEOUT = 1500;